export const RESOLUTION_OPTIONS = ["Repaired", "Decommissioned"];
